import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const ComponentHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: max-content;
  justify-content: space-between;
`;
export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 22px;
  align-items: center;
`;
export const FilterContainer = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 16px;
    width: max-content;
    align-items: center;
    border-radius: 2px;
    border: 2px solid #832729;
`;
export const FilterItem = styled.div`
    padding: 8px 20px;
    flex: 1;
    cursor: pointer;
    background: ${p => p.isSelected ? '#832729' : 'white'};
    color: ${p => !p.isSelected ? '#832729' : 'white'};
    border-right: 1px solid #832729;
`;
